import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateKitMutationVariables = Types.Exact<{
  input: Types.CreateKitInput;
}>;


export type CreateKitMutation = { __typename?: 'Mutation', createKit: { __typename?: 'KitPayload', kit?: { __typename?: 'KitStateData', kitId: string, siteIds: Array<string>, name: string, containerCode: string, startDate?: string | null, endDate?: string | null, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, lines: Array<{ __typename?: 'KitLineStateData', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateKitMutationVariables = Types.Exact<{
  input: Types.UpdateKitInput;
}>;


export type UpdateKitMutation = { __typename?: 'Mutation', updateKit: { __typename?: 'KitPayload', kit?: { __typename?: 'KitStateData', kitId: string, siteIds: Array<string>, name: string, containerCode: string, startDate?: string | null, endDate?: string | null, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, lines: Array<{ __typename?: 'KitLineStateData', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteKitMutationVariables = Types.Exact<{
  input: Types.DeleteKitInput;
}>;


export type DeleteKitMutation = { __typename?: 'Mutation', deleteKit: { __typename?: 'KitPayload', kit?: { __typename?: 'KitStateData', kitId: string, siteIds: Array<string>, name: string, containerCode: string, startDate?: string | null, endDate?: string | null, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, lines: Array<{ __typename?: 'KitLineStateData', id: string, kind: Types.KitLineKind, refId: string, multiple: number, uomCode: Types.KitLineUom, label: string, secondaryLabel: string, categoryCode?: string | null, sizeCode?: string | null, eachesPerTray?: number | null, shippingConfigCategoryCode?: string | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateKitDocument = new TypedDocumentString(`
    mutation CreateKit($input: CreateKitInput!) {
  createKit(input: $input) {
    kit {
      ...KitState
    }
    errors {
      code
      message
    }
  }
}
    fragment KitState on KitStateData {
  kitId
  siteIds
  name
  containerCode
  startDate
  endDate
  createdAt
  updatedAt
  lines {
    ...KitLineState
  }
}
fragment KitLineState on KitLineStateData {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}`);
export const UpdateKitDocument = new TypedDocumentString(`
    mutation UpdateKit($input: UpdateKitInput!) {
  updateKit(input: $input) {
    kit {
      ...KitState
    }
    errors {
      code
      message
    }
  }
}
    fragment KitState on KitStateData {
  kitId
  siteIds
  name
  containerCode
  startDate
  endDate
  createdAt
  updatedAt
  lines {
    ...KitLineState
  }
}
fragment KitLineState on KitLineStateData {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}`);
export const DeleteKitDocument = new TypedDocumentString(`
    mutation DeleteKit($input: DeleteKitInput!) {
  deleteKit(input: $input) {
    kit {
      ...KitState
    }
    errors {
      code
      message
    }
  }
}
    fragment KitState on KitStateData {
  kitId
  siteIds
  name
  containerCode
  startDate
  endDate
  createdAt
  updatedAt
  lines {
    ...KitLineState
  }
}
fragment KitLineState on KitLineStateData {
  id
  kind
  refId
  multiple
  uomCode
  label
  secondaryLabel
  categoryCode
  sizeCode
  eachesPerTray
  shippingConfigCategoryCode
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateKit: build.mutation<CreateKitMutation, CreateKitMutationVariables>({
      query: (variables) => ({ document: CreateKitDocument, variables })
    }),
    UpdateKit: build.mutation<UpdateKitMutation, UpdateKitMutationVariables>({
      query: (variables) => ({ document: UpdateKitDocument, variables })
    }),
    DeleteKit: build.mutation<DeleteKitMutation, DeleteKitMutationVariables>({
      query: (variables) => ({ document: DeleteKitDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateKitMutation, useUpdateKitMutation, useDeleteKitMutation } = injectedRtkApi;
